#import "../fragments/lead-attachments-fragment.graphql"

mutation RemoveAttachmentFromLead($input: LeadFileRemoveInput!) {
    leadFileRemove(input: $input) {
        lead {
            ...LeadAttachmentsFragment
        }
    }
}
